import ReferralSourceList from './ReferralSourceList';

// Configuration > Referral Source List, for the acting client's own list. No clientId: the API
// resolves it from the acting client.
export default function ReferralSourcesPage() {
  return <ReferralSourceList />;
}
